/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { CredentialFinding } from '../models/CredentialFinding';
import { Pagination } from '../models/Pagination';

export class ListCredentialFindingsResponse {
  'credentialFindings': Array<CredentialFinding>;
  'pagination': Pagination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "credentialFindings",
      "baseName": "credentialFindings",
      "type": "Array<CredentialFinding>",
      "format": ""
    },
    {
      "name": "pagination",
      "baseName": "pagination",
      "type": "Pagination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListCredentialFindingsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

